<!-- User Upload Article Base -->

<template>
	<div class="upload-main">

		<div class="v-spacer"></div>

		<div class="banner wi8_font">
			Upload: {{ curTitle }}
		</div>

		<div class="tab" ref="Txt" @click="clickTab('Txt')">
			<UniIcon ico="write" fit="1" pad="5" color="#369" />
		</div>

		<div class="h-spacer" />

		<div class="tab" ref="Pix" @click="clickTab('Pix')">
			<UniIcon ico="pic" fit="1" pad="5" color="#369" />
		</div>

		<div class="h-spacer" />

		<div class="tab" ref="Chk" @click="clickTab('Chk')">
			<UniIcon ico="check" fit="1" pad="5" color="#369" />
		</div>

		<div class="h-spacer" />

		<div class="content">
			<component :is="curCompName" />
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from '@/main';
import UploadPix from '@/components/UploadPix';
import UploadTxt from '@/components/UploadTxt';
import UploadChk from '@/components/UploadChk';

export default {
	data() {
		return {
			curCompName: "",
			curTitle: "Editing Article",
			titles: {
				Pix: 'Add Images',
				Txt: 'Add Story',
				Chk: 'Ready to Save?',
			},
		}
	},
	components: {
		UploadPix,
		UploadTxt,
		UploadChk,
	},
	methods: {
		clickTab(tabName) {
			Object.keys(this.$refs).forEach(refName => {
				this.$refs[refName].className = "tab";
			});
			this.$refs[tabName].className = "tab active";
			this.curTitle = this.titles[tabName];
			this.curCompName = "Upload" + tabName;
		}
	},
	created() {
		eventBus.$emit('popoffall'); // Close all modal windows
	},
	mounted() {
		m("upload mounted");
		this.clickTab("Txt");
	},
}
</script>

<style scoped>
.upload-main {
	height: 100%;
	overflow: hidden;
	background-color: #F6F6F6;
	border: solid 0px #C30;
}

.banner {
	display: inline-block;
	width: calc(100% - 165px);
	height: 40px;
	overflow: hidden;	
	/* white-space: nowrap;	 */
	vertical-align: bottom;
	padding: 5px 0px 0px 10px;
	color: #369;
	font-size: 13px;
	border: solid 0px #000;
	border-bottom: solid 1px #999;
}

.tab {
	display: inline-block;
	width: 50px;
	height: 40px;
	overflow: hidden;
	vertical-align: bottom;
	cursor: pointer;
	background-color: #EEE;
	border: solid 1px #999;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}

.active {
	background-color: #FFFCF6;
	border-bottom: solid 0px #999;
}

.h-spacer {
	display: inline-block;
	width: 5px;
	height: 10px;
	overflow: hidden;
	vertical-align: bottom;
	border: solid 0px #999;
	border-bottom: solid 1px #999;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #999;
}

.content {
	width: 100%;
	height: calc(100% - 50px);
	overflow: hidden;
	background-color: #FFFCF6;
	border: solid 0px #369;

}

</style>
